export default "__VITE_ASSET__Boseic1v__"